import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-5 min-h-[calc(100vh-64px)] bg-gray-50" }
const _hoisted_2 = { class: "text-xl px-6 font-medium text-secondary [&>a]:no-underline [&>a]:text-secondary cursor-pointer" }
const _hoisted_3 = { class: "dynamic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
        }, [
          _createElementVNode("u", null, _toDisplayString(_ctx.headerDisplayValue), 1)
        ]),
        _createTextVNode(" / Indberet")
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportCreateComponents, (componentName) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(componentName), { key: componentName }))
      }), 128))
    ])
  ]))
}